import { render, staticRenderFns } from "./BuyerCallLogs.vue?vue&type=template&id=50e0a794&scoped=true"
import script from "./BuyerCallLogs.vue?vue&type=script&lang=js"
export * from "./BuyerCallLogs.vue?vue&type=script&lang=js"
import style0 from "./BuyerCallLogs.vue?vue&type=style&index=0&id=50e0a794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0a794",
  null
  
)

export default component.exports